import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';
import LoadingSpinner from './LoadingSpinner';
import MfaVerify from '../auth/MfaVerify';
import MfaSetup from '../auth/MfaSetup';

const ProtectedRoute = ({ children, allowedRoles, platformAdmin = false }) => {
  const { user, isAuthenticated, loading, userRole, mfaStatus, refreshProfile } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner fullPage />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // The server rejects every other request until MFA is done, so show the step instead of the page.
  if (mfaStatus === 'verify') {
    return <MfaVerify />;
  }

  if (mfaStatus === 'setup') {
    return <MfaSetup onComplete={refreshProfile} />;
  }

  // Pages only for platform administrators (the server enforces this too).
  if (platformAdmin && !user?.is_platform_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  platformAdmin: PropTypes.bool
};

export default ProtectedRoute;
